<script setup lang="js">
import Lucide from "@/base-components/Lucide";
import Tippy from "@/base-components/Tippy";
import WalletHistory from "@/pages/financial/WalletHistory.vue";
import {useWalletStore} from "@/stores/walletStore.js";
import {ref, watch} from "vue";
import {useNumberFormat} from "@/composables/useNumberFormat.js";
import {formatNumber} from "../../composables/utility.js";

const walletStore = useWalletStore()

</script>

<template>
  <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y mt-5">
    <div
        :class="[
                  'relative zoom-in',
                  'before:content-[\'\'] before:w-[90%] before:shadow-[0px_3px_5px_#0000000b] before:bg-white/60 before:h-full before:mt-2.5 before:absolute before:rounded-md before:mx-auto before:inset-x-0 before:dark:bg-darkmode-400/70',
                ]"
    >
      <div class="p-5 box">
        <div class="flex">
          <Lucide
              icon="Wallet"
              class="w-[28px] h-[28px] text-warning"
          />
          <div class="mr-auto">
            <Tippy
                as="div"
                class="cursor-pointer bg-success py-[3px] flex rounded-full text-white text-xs pr-2 pl-1 items-center font-medium"
                content="شارژ کیف پول"
                @click="walletStore.openWallet"
            >
              افزایش اعتبار
              <Lucide icon="ChartBarIncreasing" class="w-4 h-4 mr-0.5"/>
            </Tippy>
          </div>
        </div>
        <div class="mt-6 text-3xl font-medium leading-8"> {{ formatNumber(walletStore.amount) }} ریال</div>
        <div class="mt-1 text-base text-slate-500">
          {{ $t('title.wallet') }}
        </div>
      </div>
    </div>
  </div>
  <WalletHistory/>
</template>

<style scoped>

</style>